import { apiGet } from "../../utils/axios.js";
import apiEndpoints from "../../apiEndpoints.js";


export function getThirdPartyRiskStats(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url)
            dispatch({
                type: 'THIRD_PARTY_RISK_STATS',
                payload: response.data
            })
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetThirdPartyRiskStats() {
    return (dispatch) => {
        dispatch({
            type: "RESET_THIRD_PARTY_RISK_STATS"
        })
    }
}

export function getSimilarDoaminList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.brandInsight.similarDomain.similarDomainList() + url)
            if(response?.status === 200) {
                dispatch({
                    type: "SIMILAR_DOMAIN_LIST_SUCCESS",
                    payload : response.data
                })
            } else {
                dispatch({
                    type: "SIMILAR_DOMAIN_LIST_SUCCESS",
                    payload : response.detail
                }) 
            }
            
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetSimilarDomainList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_SIMILAR_DOMAIN_LIST"
        })
    }
}

export function getSubDoaminList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.securityOverview.subdomain.subDomainList() + url)
            if(response?.status === 200) {
                dispatch({
                    type: "SUBDOMAIN_LIST_SUCCESS",
                    payload: response.data
                })
            } else {
                dispatch({
                    type: "SUBDOMAIN_LIST_SUCCESS",
                    payload: response.detail
                })
            }
            
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetSubdomainList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_SUBDOMAIN_LIST"
        })
    }
}

export function getIpAddressList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.securityOverview.ipAddress.ipAddressList() + url)
            if(response?.status === 200) {
                dispatch({
                    type: "IP_ADDRESS_LIST_SUCCESS",
                    payload: response.data
                })
            } else {
                dispatch({
                    type: "IP_ADDRESS_LIST_SUCCESS",
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetIpAddressList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_IP_ADDRESS_LIST"
        })
    }
}

export function getCVEsList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.riskAssessment.criticalVulnerabilities.cvesList() + url)
            if(response?.status === 200) {
                dispatch({
                    type: "CVES_LIST_SUCCESS",
                    payload: response.data
                })
            } else {
                dispatch({
                    type: "CVES_LIST_SUCCESS",
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetCvesList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_CVES_LIST"
        })
    }
}

export function getSubdomainTakeoverList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.riskAssessment.subdomainTakeover.subdomainTakeoverList() + url)
            if(response?.status === 200) {
                dispatch({
                    type: "SUBDOMAIN_TAKEOVER_LIST_SUCCESS",
                    payload: response.data
                })
            } else {
                dispatch({
                    type: "SUBDOMAIN_TAKEOVER_LIST_SUCCESS",
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetSubdomainTakeoverList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_SUBDOMAIN_TAKEOVER_LIST"
        })
    }
}

export function getSSLVulnerabilitiesList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.riskAssessment.sslVulnerabilities.sslVulnerabilitiesList() + url)
            if(response?.status === 200) {
                dispatch({
                    type: "SSL_VULNERABILITIES_LIST_SUCCESS",
                    payload: response.data
                })
            } else {
                dispatch({
                    type: "SSL_VULNERABILITIES_LIST_SUCCESS",
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetSSLVulnerabilitiesList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_SSL_VULNERABILITIES_LIST"
        })
    }
}

export function getBotnetLeakList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.compromiseIndicator.botnetLeaks.botnetLeaksList() + url)
            if(response?.status === 200) {
                dispatch({
                    type: "BOTNET_LEAKS_LIST_SUCCESS",
                    payload: response.data
                })
            } else {
                dispatch({
                    type: "BOTNET_LEAKS_LIST_SUCCESS",
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetBotnetLeakList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_BOTNET_LEAKS_LIST"
        })
    }
}

export function getLeakedCredentialsList (url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.compromiseIndicator.leakedCredentials.leakedCredentialsList() + url)
            if(response?.status === 200) {
                dispatch({
                    type: "LEAKED_CREDENTIALS_LIST_SUCCESS",
                    payload: response.data
                })
            } else {
                dispatch({
                    type: "LEAKED_CREDENTIALS_LIST_SUCCESS",
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export function resetLeakedCredentialsList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_LEAKED_CREDENTIALS_LIST"
        })
    }
}

export function geCERStats(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.corporateEmailRisk.cerStats()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'CER_STATS_SUCCESS',
                    payload: response.data.stats
                })
            } else {
                dispatch({
                    type: 'CER_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetCERStatus() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_CER_STATUS'
        })
    }
}

export function getCERData(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(url);
            if(response?.status === 200) {
                dispatch({
                    type: 'CER_DATA_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'CER_DATA_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetCERDataList() {
    return (dispatch) => {
        dispatch({
            type: "RESET_CER_DATA_LIST"
        })
    }
}

export function getRiskOverTime(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.riskOverTime()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'RISK_OVER_TIME_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'RISK_OVER_TIME_SUCCESS',
                    payload: response.detail
                })
            }            
        } catch(error) {
            console.log(error)
        }
    }
}

export function resetRiskOverTimeValue(){
    return (dispatch) => {
        dispatch({
            type: "RESET_RISK_OVER_TIME"
        })
    }
}

export function getRiskAssessment(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.riskAssessment()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'RISK_ASSESSMENT_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'RISK_ASSESSMENT_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error)
        }
    }
}

export function getSecurityOverview(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.securityOverview()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'SECURITY_OVERVIEW_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'SECURITY_OVERVIEW_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error)
        }
    }
}

export function getCompromiseIndicator(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.compromiseIndicator()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'COMPROMISE_INDICATOR_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'COMPROMISE_INDICATOR_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error)
        }
    }
}

export function getBrandInsight(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.brandInsight()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'BRAND_INSIGHT_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'BRAND_INSIGHT_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error)
        }
    }
}

export function getOverallRiskScore(params) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.overallRiskScore()+params)
            if(response.status === 200) {
                dispatch({
                    type: 'OVERALL_RISK_SCORE_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'OVERALL_RISK_SCORE_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error)
        }
    }
}

export function getThirdPartyVendorStats(customerId){
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.dashboardOverview.thirdPartyVendorStats()+`&customer_id=${customerId}`)
            if(response.status === 200) {
                dispatch({
                    type: 'THIRD_PARTY_VENDOR_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'THIRD_PARTY_VENDOR_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error)
        }
    }
}

export function resetThirdPartyVendorStats() {
    return (dispatch) => {
        dispatch({
            type: "RESET_THIRD_PARTY_VENDOR_STATS"
        })
    }
}

export function getVendorRiskProfile(customerId){
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.dashboardOverview.vendorRiskProfile()+`&customer_id=${customerId}`)
            if(response.status === 200) {
                dispatch({
                    type: 'VENDOR_RISK_PROFILE_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'VENDOR_RISK_PROFILE_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error)
        }
    }
}

export function resetVendorRiskProfile() {
    return (dispatch) => {
        dispatch({
            type: "RESET_VENDOR_RISK_PROFILE_LIST"
        })
    }
}

export function getVendorOverview(customerId) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.dashboardOverview.vendorOverviewStats()+`&customer_id=${customerId}`)
            if(response.status === 200) {
                dispatch({
                    type: 'VENDOR_OVERVIEW_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'VENDOR_OVERVIEW_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error)
        }
    }
}

export function resetVendorOverview() {
    return (dispatch) => {
        dispatch({
            type: "RESET_VENDOR_OVERVIEW_LIST"
        })
    }
}

export function getVendorScoreChange(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.dashboardOverview.vendorScoreChange()+url)
            if(response.status === 200) {
                dispatch({
                    type: 'VENDOR_SCORE_CHANGE_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'VENDOR_SCORE_CHANGE_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error)
        }
    }
}

export function resetVendorScoreChange() {
    return (dispatch) => {
        dispatch({
            type: "RESET_VENDOR_SCORE_CHANGE"
        })
    }
}

export function getVendorRiskBusinessImpact(customerId){
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.dashboardOverview.vendorRiskBusinessImapct()+`&customer_id=${customerId}`)
            if(response.status === 200) {
                dispatch({
                    type: 'VENDOR_RISK_BUSINESS_IMPACT_LIST_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'VENDOR_RISK_BUSINESS_IMPACT_LIST_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error)
        }
    }
}

export function resetVendorRiskBusinessImpact() {
    return (dispatch) => {
        dispatch({
            type: "RESET_VENDOR_RISK_BUSINESS_IMPACT_LIST"
        })
    }
}

export function getGitLeaks(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.exposureManagemnet.concerningExposure.gitLeaks.gitLeaksList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'GIT_LEAKS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'GIT_LEAKS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function resetGitLeaksList() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_GIT_LEAKS_LIST'
        })
    }
}

export function getRansomweregroupData(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.compromiseIndicator.ransomewareGroupLeaks.ransomewareGroupLeakList()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'RANSOMEWARE_DATA_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'RANSOMEWARE_DATA_SUCCESS',
                    payload: response.detail
                })
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export function getRiskScoreOverview(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.overallRiskScoreOverview()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'OVERALL_RISK_SCORE_OVERVIEW_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'OVERALL_RISK_SCORE_OVERVIEW_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error);
        }
    }
}

export function getCyberRatingStats(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.cyberRatingStats()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'CYBER_RATING_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'CYBER_RATING_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error);
        }
    }
}

export function getDigitalFootPrint(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.digitalFootPrintStats()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'DIGITAL_FOOTPRINT_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'DIGITAL_FOOTPRINT_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error);
        }
    }
}

export function getRiskFindingStats(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.riskFindingsStats()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'RISK_FINDINGS_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'RISK_FINDINGS_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error);
        }
    }
}

export function getTopTechnologies(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.topTechnologiesStats()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'TOP_TECHNOLOGIES_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'TOP_TECHNOLOGIES_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error);
        }
    }
}

export function getTopVulnerabilities(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.topVulnerabilitiesStats()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'TOP_VULNERABILITIES_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'TOP_VULNERABILITIES_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error);
        }
    }
}

export function getSSLExpiryStats(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.sslExpiryStats()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'SSL_EXPIRY_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'SSL_EXPIRY_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error);
        }
    }
}

export function getSSLStatusStats(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.sslVulnerabilitiesStats()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'SSL_VULNERABILITIES_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'SSL_VULNERABILITIES_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error);
        }
    }
}

export function getBecStats(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.becStatus()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'BEC_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'BEC_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error);
        }
    } 
}

export function getVendorRiskCountryStats(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.countryStats()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'COUNTRY_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'COUNTRY_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error);
        }
    } 
}

export function getVulnerabilitiesTrend(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.vendorRiskProfile.vulnerabilitiesTrend()+url);
            if(response?.status === 200) {
                dispatch({
                    type: 'VULNERABILITIES_TREND_STATS_SUCCESS',
                    payload: response.data
                })
            } else {
                dispatch({
                    type: 'VULNERABILITIES_TREND_STATS_SUCCESS',
                    payload: response.detail
                })
            }
        } catch(error) {
            console.log(error);
        }
    } 
}